import { render, staticRenderFns } from "./ReporteTrasabilidad.vue?vue&type=template&id=b7fc4b86"
import script from "./ReporteTrasabilidad.vue?vue&type=script&lang=js"
export * from "./ReporteTrasabilidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports